import { Button, Grid, Box as MuiBox, Typography } from '@mui/material';

interface MessageBoxType {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  image: string;
  fullWidth?: boolean;
}

const MessageBox = ({ image, title, subtitle, fullWidth }: MessageBoxType) => {
  return (
    <MuiBox
      display="flex"
      justifyContent="center"
      height={{ xs: 'auto' }}
      width="100%"
    >
      <Grid
        container
        padding={2}
        borderRadius={2}
        bgcolor="background.secondary"
        width={fullWidth ? { xs: '100%' } : { xs: '100%', lg: '800px' }}
        display="flex"
        justifyContent="space-between"
        spacing={2}
        flexDirection={{ xs: 'column', md: 'row' }}
        flexWrap="nowrap"
        margin={0}
      >
        <Grid
          container
          item
          textAlign="left"
          spacing={1}
          display="flex"
          flexDirection={{ xs: 'column', lg: 'row' }}
          flexWrap="nowrap"
          padding="16px"
        >
          <Grid item xs={2} padding={0}>
            <MuiBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              width={{ xs: '50px', lg: '100%' }}
            >
              <img src={image} height="50px" width="50px" alt="Logomark" />
            </MuiBox>
          </Grid>
          <Grid
            item
            xs={10}
            display="flex"
            justifyContent="center"
            alignItems="flex-start"
            flexDirection="column"
          >
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body1">
              {subtitle ||
              <span>
                Give us a call at +1 (212)
                266-0020 or navigate to the top of the page to access out
                {' '}
                <a
                  href="mailto: ri.pm@theguarantors.com"
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  FAQs
                </a>
                .
              </span>}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          display="flex"
          justifyContent={{ xs: 'flex-start', md: 'center' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
        >
          <Button
            variant="contained"
            sx={{ bgcolor: 'transparent', color: 'inherit' }}
            href={`tel:+12122660020`}
          >
            Call Support
          </Button>
        </Grid>
      </Grid>
    </MuiBox>
  );
};

export default MessageBox;
